/**
 * Created by matei on 2019-06-19
 */

import Checkbox from './checkbox';

export default Checkbox;
